import App from '../app';

class PageController {

	attributes = {
		slug: 'data-page-slug',
		previousPage: 'data-previous-page',
		currentPage: 'data-current-page'
	};

	container;

	pages = {};

	active;
	previous;

	activate() {
		if (this.previous) document.body.setAttribute(this.attributes.previousPage, this.previous);
		document.body.setAttribute(this.attributes.currentPage, this.active);
	}

	createPage(slug) {
		this.pages[slug] = document.createElement('div');
		this.pages[slug].setAttribute(this.attributes.slug, slug);
	}

	detect() {
		const page = this.container.querySelector(`[${this.attributes.slug}]`);
		if (!page) return false;

		const slug = page.getAttribute(this.attributes.slug);

		this.previous = this.active;
		this.active = slug;

		this.pages[slug] = page;

		this.activate();

		App.apply(slug);

		return this.pages[slug];
	}

	async open(slug) {
		this.previous = this.active;
		this.active = slug;

		let path = '/';
		if (slug !== 'home') path += `${slug}/`;

		// TODO http status
		const html = await fetch(`${path}body.php`).then((res) => (res.ok ? res.text() : fetch('/404/body.php').then((r) => r.text()))).catch(() => fetch('/404/body.php').then((r) => r.text()));

		if (this.pages[slug]) this.close(slug);
		this.createPage(slug);
		this.pages[slug].innerHTML = html;
		this.container.append(this.pages[slug]);

		this.activate();

		App.apply(slug);

		return this.pages[slug];
	}

	close(slug = this.active) {
		if (this.pages[slug]) {
			this.pages[slug].remove();
			delete this.pages[slug];
		}
	}

}

export default new PageController();
